<template>
    <div id="edit-address" class="account-address-add uk-modal-container" uk-modal>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
                <h2 class="uk-modal-title">{{ $t('frontend-action.edit') }}</h2>
            </div>
            <div class="uk-modal-body">
                <div v-cloak>
                    <address-form ref="form" class="uk-form-stacked" validateOnChange="true" :allow-only-one-billing-address="allowOnlyOneBillingAddress" :previous-billing-address="previousBillingAddress" :edit-address="addressId">
                        <div class="uk-grid-small" slot="fields" uk-grid>
                            <slot></slot>
                        </div>
                        <div class="uk-margin-top uk-text-right@m" slot="submit">
                            <a @click="submitForm()" class="uk-button uk-button-primary uk-width-1-1 uk-width-auto@m">{{ $t('frontend-action.save') }}</a>
                        </div>
                    </address-form>
                </div>
            </div>
            <div class="uk-modal-footer uk-hidden@s uk-text-center">
                <a class="uk-button uk-button-link uk-modal-close">{{ $t('frontend-action.close') }}</a>
            </div>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';
    export default {
      props: {
        allowOnlyOneBillingAddress: {
          type: Boolean,
          default: false,
        },
        previousBillingAddress: {
          type: Number,
        },
      },
      data() {
        return {
          fields: [],
          addressId: 0,
        }
      },
      methods: {
        populateFields(address) {
          this.clearFields();
          //set the address id and types
          this.addressId = address.id;
          this.$refs.form.type = address.type;
          this.$refs.form.setValues(address);
          this.$refs.form.customerTypeField.fieldValue = address.customer_type;
          this.$refs.form.toggleBillingFields();

          // this.fields.forEach(field => {
          //   if(typeof address[field.slug] === 'object') {
          //     if(address[field.slug]) {
          //       field.setValue(address[field.slug].id);
          //     }
          //   } else {
          //     field.setValue(address[field.slug]);
          //   }
          // });
        },

        clearFields() {
          this.addressId = 0;
          this.fields.forEach(field => {
            field.setValue('');
          });
        },

        submitForm() {
          let self = this;
          let payload = {
            //if editing
            id: self.addressId > 0 ? self.addressId : undefined,
          };
          this.fields.forEach(field => {
            if (field.slug === 'vat' || field.slug === 'fiscal_code') {
              field.enabled = !field.disabled;
            }
            payload[field.name] = field.getValue();
          });

          if(this.$refs.form.performValidation()) {
            this.$store.dispatch('addressBook/submit', payload);
            window.App.UIkit.modal(document.querySelector('#edit-address')).hide();
            this.$refs.form.resetValidations();
          }
        }
      },
      created() {
        let self = this;

        window.App.$on('rubinred.address.create', e => {
          self.clearFields();
          window.App.UIkit.modal(document.querySelector('#edit-address')).show();
        });

        window.App.$on('rubinred.address.edit', address => {
          self.populateFields(address);
          window.App.UIkit.modal(document.querySelector('#edit-address')).show();
        });
      },
      mounted() {
        this.fields = this.$refs.form.fields;
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressModal.vue